export enum PlanTemplateType {
    Blank = 1,
    Bikeshop = 2,
    StandardBusinessTemplate = 3,
    Yamaha = 4,
    CoffeeShop = 5,
    Consulting = 6,
    Ecommerce = 7,
    FoodVan = 8,
    Gardening = 9,
    Manufacturing = 10,
    Photography = 11,
    Restaurant = 12,
    Retail = 13,
    SAAS = 14,
    BikeshopBlank = 15
}